import type {
  FilterSegmentVariableDefinition,
  ResultRecord,
  ResultRecordValue,
} from '@dynatrace-sdk/client-query';

/**
 * @internal
 */
export function convertQueryRecordToStoreSegmentVariables(
  records: (ResultRecord | null)[],
): FilterSegmentVariableDefinition[] {
  if (records.length === 0) {
    return [];
  }

  const allKeys = Object.keys(records[0] ?? {});

  return allKeys.map((key) => {
    const values = records.map((singleRow) => {
      if (!singleRow || !(key in singleRow)) {
        return 'null';
      }

      // According to DQL they are always a string; I'm not sure why the type says differently.
      return parseResultRecordValue(singleRow[key]);
    });

    return { name: key, values };
  });
}

/**
 *
 * @param record - ResultRecordValue
 * @returns stringified version of the result
 * @internal
 */
export function parseResultRecordValue(record?: ResultRecordValue) {
  if (!record) {
    return 'null';
  }

  if (typeof record === 'string') {
    return record.toString();
  }

  return JSON.stringify(record);
}
